import ProfileAccountInformationForm from './ProfileAccountInformationForm'

export default ProfileAccountInformationForm
